import React, { useRef } from 'react';
var VeltCommentsSidebarV2Skeleton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-skeleton-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2Skeleton;
